import React, { useEffect, useState } from 'react'
import { LoadAllContact } from '../actions/ActivitesPages/ManagerPageAction';
import { MdOutlineFacebook } from "react-icons/md";
import { BsYoutube } from "react-icons/bs";



const SocialMedia = () => {



    const [id, setid] = useState();

    const [coverPicture, setcoverPicture] = useState();
    const [logo, setlogo] = useState();
    const [name, setname] = useState();
    const [email, setemail] = useState();
    const [telephone1, settelephone1] = useState();
    const [telephone2, settelephone2] = useState();
    const [telephone3, settelephone3] = useState();

    const [facebook, setfacebook] = useState();
    const [youtube, setyoutube] = useState();
    const [instagram, setinstagram] = useState();



    const [Loading, setLoading] = useState();

    useEffect(() => {
        LoadAllContact(setid, setlogo, setname, setcoverPicture,
            setemail, settelephone1, settelephone2, settelephone3,
            setfacebook, setyoutube, setinstagram)
    }, []);

    return (
        <div className="container-fluid flex flex-col my-3 bg-cover bg-no-repeat">
            <div className="container place-items-center mx-auto py-10 px-10 sm:my-auto border shadow-sm bg-white rounded-3xl space-y-10">
                <div className="w-full flex justify-center">
                    <div className="border-start border-3 rounded-lg border-primary px-5 mb-5" >
                        <h6 className="text-primary  text-uppercase text-xl"></h6>
                        <h1 className="display-6 text-uppercase mb-0 text-center translatable">Reseaux Sociaux</h1>
                    </div>
                </div>
                <div className="flex items-center justify-center space-x-3">

                    <a href={`${facebook}`} target='_blank' className="bg-blue-600 px-4 py-2 font-semibold text-white inline-flex items-center space-x-2 rounded">
                        <MdOutlineFacebook />
                        <span className="translatable">Facebook</span>
                    </a>


                    <a href={`${youtube}`} target='_blank' className="bg-red-600 px-4 py-2 font-semibold text-white inline-flex items-center space-x-2 rounded">
                        <BsYoutube />
                        <span className="translatable">Youtube</span>
                    </a>


                </div>
            </div>
        </div>
    )
}

export default SocialMedia
